import React from 'react'

interface Props {
  left: React.ReactNode
  right: React.ReactNode
}

function ModalTwoColumnLayout({ left, right }: Props) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
      }}
    >
      {left}
      {right}
    </div>
  )
}

export default ModalTwoColumnLayout
